import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["action", "checked", "disabled", "error", "id", "label", "labelHidden", "labelPlacement", "labelProps", "message", "onChange", "optionalLabel", "required"];
import '../../css-tokens';
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Checkmark } from '@mediahuis/chameleon-theme-wl/icons';
import system from '../../system';
import Icon from '../Icon';
import Label, { getPlacement } from '../Label';
import Box from '../Box';
import Message from '../Message';
import styles from './index.module.css';
var SYSTEM_PROPS = ['marginProps', 'floatProps'];

const Checkbox = /*#__PURE__*/function () {
  const Checkbox = /*#__PURE__*/forwardRef(function (_ref, ref) {
    var action = _ref.action,
        checked = _ref.checked,
        disabled = _ref.disabled,
        error = _ref.error,
        id = _ref.id,
        label = _ref.label,
        labelHidden = _ref.labelHidden,
        labelPlacement = _ref.labelPlacement,
        labelProps = _ref.labelProps,
        message = _ref.message,
        onChange = _ref.onChange,
        optionalLabel = _ref.optionalLabel,
        required = _ref.required,
        props = _objectWithoutPropertiesLoose(_ref, _excluded);

    var _system = system(props, SYSTEM_PROPS),
        className = _system[0],
        style = _system[1],
        rest = _system[2];

    var labelId = id + "-label";
    var messageId = id + "-message";

    var _getPlacement = getPlacement(labelPlacement),
        rootClassName = _getPlacement.rootClassName,
        iconClassName = _getPlacement.iconClassName,
        inputClassName = _getPlacement.inputClassName,
        labelWidth = _getPlacement.labelWidth,
        labelLeftMargin = _getPlacement.labelLeftMargin;

    return /*#__PURE__*/React.createElement("label", {
      className: cx(styles.root, error && styles.error, rootClassName, className),
      style: style,
      htmlFor: id,
      id: labelId
    }, /*#__PURE__*/React.createElement("input", _extends({
      id: id,
      type: "checkbox",
      className: cx(styles.input, inputClassName),
      "aria-describedby": message && messageId,
      "aria-labelledby": labelId,
      "aria-invalid": !!error,
      "aria-checked": checked,
      required: optionalLabel ? false : required,
      checked: checked,
      onChange: onChange,
      disabled: disabled,
      ref: ref
    }, rest)), /*#__PURE__*/React.createElement("div", {
      className: cx(styles.iconContainer, styles.checkboxContainer, iconClassName)
    }, /*#__PURE__*/React.createElement(Icon, {
      className: styles.icon,
      as: Checkmark,
      size: "small"
    })), /*#__PURE__*/React.createElement(Box, {
      width: !labelHidden ? labelWidth : 0,
      ml: !labelHidden ? labelLeftMargin : 0
    }, /*#__PURE__*/React.createElement(Label, _extends({}, labelProps, {
      hidden: labelHidden,
      as: "span",
      width: "auto",
      action: action,
      alignItems: "baseline",
      optional: optionalLabel
    }), label), message && /*#__PURE__*/React.createElement(Box, {
      pt: 2,
      clone: true
    }, /*#__PURE__*/React.createElement(Message, {
      error: error,
      id: messageId
    }, message))));
  });
  Checkbox.displayName = 'Checkbox';
  Checkbox.identifier = Checkbox.displayName; // used in docs website

  Checkbox.clonableProps = SYSTEM_PROPS;
  return Checkbox;
}();

export default Checkbox;